import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import ScheduleSectionTitle from '../ScheduleSectionTitle';
import ScheduleDailyCalendar from './DailyCalendar';
import AgendaHeader from './AgendaHeader';
import Meeting from './Meeting';

const styles = theme => ({
  root: {
    display: 'flex',
    flex: 1,
  },
  schedule: {
    display: 'flex',
    flexDirection: 'column',
  },
  agenda: {
    flex: 1,
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
  },
  scheduleSectionNoMeeting: {
    display: 'flex',
    flex: 1,
    marginTop: theme.spacing(12),
    borderRadius: '13px',
    height: '100%',
  },
  noMeetingText: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: 'auto',
    color: theme.palette.facet.primaryGray,
  },
});

const ScheduleDailyView = ({
  actionItemLinkCount,
  className,
  classes,
  date,
  handleDecrementDate,
  handleIncrementDate,
  handleResetDate,
  meetingCollection,
  meetingResource,
  handleToggleDailyView,
  meetingCollectionLoading,
  ...rest
}) => {
  return (
    <div className={classNames(classes.root, className)}>
      <div className={classes.schedule}>
        <ScheduleSectionTitle
          onDecrementDate={handleDecrementDate}
          onIncrementDate={handleIncrementDate}
          onResetDate={handleResetDate}
          buttonText="Today"
          formattedDate={date.format('dddd MMMM Do')}
        />
        <ScheduleDailyCalendar
          date={date}
          scheduleEvents={[...meetingCollection]}
          actionItemLinkCount={actionItemLinkCount}
          handleToggleDailyView={handleToggleDailyView}
          meetingCollectionLoading={meetingCollectionLoading}
        />
      </div>
      <div className={classes.agenda}>
        {meetingResource ? (
          <>
            <AgendaHeader meetingResource={meetingResource} />
            <Meeting meetingResource={meetingResource} {...rest} />
          </>
        ) : (
          <Paper elevation={0} className={classes.scheduleSectionNoMeeting}>
            <Typography
              className={classes.noMeetingText}
              variant="h2"
            >
                No meeting selected
            </Typography>
          </Paper>
        )}
      </div>
    </div>
  );
};

ScheduleDailyView.defaultProps = {
  className: '',
};

ScheduleDailyView.propTypes = {
  actionItemLinkCount: PropTypes.object.isRequired,
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  date: PropTypes.object.isRequired,
  handleDecrementDate: PropTypes.func.isRequired,
  handleIncrementDate: PropTypes.func.isRequired,
  handleResetDate: PropTypes.func.isRequired,
  meetingCollection: PropTypes.array.isRequired,
  meetingResource: PropTypes.object.isRequired,
  handleToggleDailyView: PropTypes.func.isRequired,
  meetingCollectionLoading: PropTypes.bool.isRequired,
};

export default withStyles(styles)(ScheduleDailyView);
